import { PlanningParam } from '../store/types';

// ---------------------------------------------------------------------------
// Products — 29 NDCs across 12 rooms
// ---------------------------------------------------------------------------
export const MOCK_PRODUCTS = [
  // Purple (HS1, room_type_id 2) — RUN, EBQ 4000-6000
  { NDC11: '51407-0101-01', StockCode: 'SC-0101', Description: 'Tramadol HCl 50mg',    JobType: 'RUN',     RoomType: 'HIGH', RoomName: 'Purple', RoomTypeId: 2, BPM: 105, Ebq: 5000 },
  { NDC11: '51407-0102-01', StockCode: 'SC-0102', Description: 'Metformin HCl 500mg',  JobType: 'RUN',     RoomType: 'HIGH', RoomName: 'Purple', RoomTypeId: 2, BPM: 110, Ebq: 6000 },
  { NDC11: '51407-0103-01', StockCode: 'SC-0103', Description: 'Metformin HCl 1000mg', JobType: 'RUN',     RoomType: 'HIGH', RoomName: 'Purple', RoomTypeId: 2, BPM:  95, Ebq: 4000 },
  // Green (HS1, room_type_id 2)
  { NDC11: '60429-0201-01', StockCode: 'SC-0201', Description: 'Lisinopril 10mg',      JobType: 'RUN',     RoomType: 'HIGH', RoomName: 'Green',  RoomTypeId: 2, BPM: 100, Ebq: 5000 },
  { NDC11: '60429-0202-01', StockCode: 'SC-0202', Description: 'Lisinopril 20mg',      JobType: 'RUN',     RoomType: 'HIGH', RoomName: 'Green',  RoomTypeId: 2, BPM:  98, Ebq: 4500 },
  { NDC11: '60429-0203-01', StockCode: 'SC-0203', Description: 'Amlodipine 5mg',       JobType: 'RUN',     RoomType: 'HIGH', RoomName: 'Green',  RoomTypeId: 2, BPM: 108, Ebq: 5500 },
  // Gold (HS2, room_type_id 8)
  { NDC11: '51407-0301-01', StockCode: 'SC-0301', Description: 'Sumatriptan 50mg',     JobType: 'RUN',     RoomType: 'HIGH', RoomName: 'Gold',   RoomTypeId: 8, BPM:  88, Ebq: 3500 },
  { NDC11: '51407-0302-01', StockCode: 'SC-0302', Description: 'Sumatriptan 100mg',    JobType: 'RUN',     RoomType: 'HIGH', RoomName: 'Gold',   RoomTypeId: 8, BPM:  85, Ebq: 3000 },
  { NDC11: '51407-0303-01', StockCode: 'SC-0303', Description: 'Losartan 50mg',        JobType: 'RUN',     RoomType: 'HIGH', RoomName: 'Gold',   RoomTypeId: 8, BPM:  92, Ebq: 4000 },
  // Blue (HS2, room_type_id 8)
  { NDC11: '60429-0401-01', StockCode: 'SC-0401', Description: 'Omeprazole 20mg',      JobType: 'RUN',     RoomType: 'HIGH', RoomName: 'Blue',   RoomTypeId: 8, BPM:  82, Ebq: 4000 },
  { NDC11: '60429-0402-01', StockCode: 'SC-0402', Description: 'Omeprazole 40mg',      JobType: 'RUN',     RoomType: 'HIGH', RoomName: 'Blue',   RoomTypeId: 8, BPM:  80, Ebq: 3500 },
  { NDC11: '60429-0403-01', StockCode: 'SC-0403', Description: 'Pantoprazole 40mg',    JobType: 'RUN',     RoomType: 'HIGH', RoomName: 'Blue',   RoomTypeId: 8, BPM:  86, Ebq: 3000 },
  // Silver (Medium Speed, room_type_id 3)
  { NDC11: '60429-1901-01', StockCode: 'SC-1901', Description: 'Sertraline 50mg',      JobType: 'RUN',     RoomType: 'HIGH', RoomName: 'Silver', RoomTypeId: 3, BPM:  94, Ebq: 5000 },
  { NDC11: '60429-1902-01', StockCode: 'SC-1902', Description: 'Sertraline 100mg',     JobType: 'RUN',     RoomType: 'HIGH', RoomName: 'Silver', RoomTypeId: 3, BPM:  90, Ebq: 4500 },
  { NDC11: '60429-1903-01', StockCode: 'SC-1903', Description: 'Escitalopram 10mg',    JobType: 'RUN',     RoomType: 'HIGH', RoomName: 'Silver', RoomTypeId: 3, BPM: 102, Ebq: 5500 },
  // Black (Low Speed 2, room_type_id 6) — DUMP
  { NDC11: '51407-0501-01', StockCode: 'SC-0501', Description: 'Gabapentin 300mg',     JobType: 'DUMP',    RoomType: 'LOW',  RoomName: 'Black',  RoomTypeId: 6, BPM:  90, Ebq: 1500 },
  { NDC11: '51407-0502-01', StockCode: 'SC-0502', Description: 'Gabapentin 600mg',     JobType: 'DUMP',    RoomType: 'LOW',  RoomName: 'Black',  RoomTypeId: 6, BPM:  84, Ebq: 2000 },
  { NDC11: '51407-0503-01', StockCode: 'SC-0503', Description: 'Pregabalin 75mg',      JobType: 'DUMP',    RoomType: 'LOW',  RoomName: 'Black',  RoomTypeId: 6, BPM:  96, Ebq: 2500 },
  // RedC (Low Speed 1, room_type_id 1) — RUN small
  { NDC11: '51407-1401-01', StockCode: 'SC-1401', Description: 'Doxycycline 100mg',    JobType: 'RUN',     RoomType: 'LOW',  RoomName: 'RedC',   RoomTypeId: 1, BPM:  45, Ebq:  800 },
  { NDC11: '51407-1402-01', StockCode: 'SC-1402', Description: 'Amoxicillin 500mg',    JobType: 'RUN',     RoomType: 'LOW',  RoomName: 'RedC',   RoomTypeId: 1, BPM:  50, Ebq:  900 },
  { NDC11: '51407-1403-01', StockCode: 'SC-1403', Description: 'Cephalexin 250mg',     JobType: 'RUN',     RoomType: 'LOW',  RoomName: 'RedC',   RoomTypeId: 1, BPM:  42, Ebq:  750 },
  // RedD (Low Speed 1, room_type_id 1) — RUN small
  { NDC11: '51407-1404-01', StockCode: 'SC-1404', Description: 'Fluconazole 150mg',           JobType: 'RUN',     RoomType: 'LOW',  RoomName: 'RedD',   RoomTypeId: 1, BPM:  38, Ebq:  850 },
  { NDC11: '60429-1501-01', StockCode: 'SC-1501', Description: 'Hydroxychloroquine 200mg',    JobType: 'RUN',     RoomType: 'LOW',  RoomName: 'RedD',   RoomTypeId: 1, BPM:  55, Ebq:  700 },
  { NDC11: '60429-1502-01', StockCode: 'SC-1502', Description: 'Prednisone 10mg',             JobType: 'RUN',     RoomType: 'LOW',  RoomName: 'RedD',   RoomTypeId: 1, BPM:  58, Ebq:  950 },
  // WhiteA (Overlay, room_type_id 4)
  { NDC11: '51407-0601-01', StockCode: 'SC-0601', Description: 'Tramadol ER 200mg',    JobType: 'OVERLAY', RoomType: 'OVER', RoomName: 'WhiteA', RoomTypeId: 4, BPM:  15, Ebq: 1000 },
  { NDC11: '51407-0602-01', StockCode: 'SC-0602', Description: 'Venlafaxine ER 75mg',  JobType: 'OVERLAY', RoomType: 'OVER', RoomName: 'WhiteA', RoomTypeId: 4, BPM:  18, Ebq:  800 },
  // WhiteB (Overlay, room_type_id 4)
  { NDC11: '51407-0603-01', StockCode: 'SC-0603', Description: 'Venlafaxine ER 150mg', JobType: 'OVERLAY', RoomType: 'OVER', RoomName: 'WhiteB', RoomTypeId: 4, BPM:  16, Ebq:  750 },
  // RedC — RECAP
  { NDC11: '60429-1701-01', StockCode: 'SC-1701', Description: 'Methylphenidate ER 27mg', JobType: 'RECAP', RoomType: 'LOW', RoomName: 'RedC',  RoomTypeId: 1, BPM:  12, Ebq:  600 },
  { NDC11: '60429-1702-01', StockCode: 'SC-1702', Description: 'Methylphenidate ER 36mg', JobType: 'RECAP', RoomType: 'LOW', RoomName: 'RedD',  RoomTypeId: 1, BPM:  11, Ebq:  500 },
];

// ---------------------------------------------------------------------------
// Rooms — 12 rooms
// ---------------------------------------------------------------------------
export const MOCK_ROOMS = [
  { room_id:  1, room_short: 'PU', room_long: 'Purple', room_type_id: 2, room_type_description: 'High Speed 1', room_category: 'HIGH' },
  { room_id:  2, room_short: 'GR', room_long: 'Green',  room_type_id: 2, room_type_description: 'High Speed 1', room_category: 'HIGH' },
  { room_id:  3, room_short: 'GO', room_long: 'Gold',   room_type_id: 8, room_type_description: 'High Speed 2', room_category: 'HIGH' },
  { room_id:  4, room_short: 'BL', room_long: 'Blue',   room_type_id: 8, room_type_description: 'High Speed 2', room_category: 'HIGH' },
  { room_id: 19, room_short: 'SI', room_long: 'Silver', room_type_id: 3, room_type_description: 'Medium Speed',  room_category: 'HIGH' },
  { room_id:  5, room_short: 'BK', room_long: 'Black',  room_type_id: 6, room_type_description: 'Low Speed 2',  room_category: 'LOW'  },
  { room_id:  6, room_short: 'RC', room_long: 'RedC',   room_type_id: 1, room_type_description: 'Low Speed 1',  room_category: 'LOW'  },
  { room_id:  7, room_short: 'RD', room_long: 'RedD',   room_type_id: 1, room_type_description: 'Low Speed 1',  room_category: 'LOW'  },
  { room_id:  8, room_short: 'RB', room_long: 'RedB',   room_type_id: 1, room_type_description: 'Low Speed 1',  room_category: 'LOW'  },
  { room_id:  9, room_short: 'WA', room_long: 'WhiteA', room_type_id: 4, room_type_description: 'Overlay',      room_category: 'OVER' },
  { room_id: 10, room_short: 'WB', room_long: 'WhiteB', room_type_id: 4, room_type_description: 'Overlay',      room_category: 'OVER' },
  { room_id: 20, room_short: 'SA', room_long: 'SAPS',   room_type_id: 5, room_type_description: 'SAPS',         room_category: 'SAPS' },
];

// ---------------------------------------------------------------------------
// Calendar — 12 months Apr 2026 – Mar 2027
// ---------------------------------------------------------------------------
export const MOCK_CALENDAR = [
  { month: '2026-04', work_days: 22 },
  { month: '2026-05', work_days: 20 },
  { month: '2026-06', work_days: 22 },
  { month: '2026-07', work_days: 21 },
  { month: '2026-08', work_days: 21 },
  { month: '2026-09', work_days: 21 },
  { month: '2026-10', work_days: 22 },
  { month: '2026-11', work_days: 19 },
  { month: '2026-12', work_days: 21 },
  { month: '2027-01', work_days: 20 },
  { month: '2027-02', work_days: 20 },
  { month: '2027-03', work_days: 23 },
];

// ---------------------------------------------------------------------------
// Holidays — Apr 2026 – Mar 2027 planning window
// ---------------------------------------------------------------------------
export interface MockHoliday {
  id: string;
  date: string;   // YYYY-MM-DD
  name: string;
}

export const MOCK_HOLIDAYS: MockHoliday[] = [
  { id: 'h01', date: '2026-05-25', name: 'Memorial Day'               },
  { id: 'h02', date: '2026-07-04', name: 'Independence Day'           },
  { id: 'h03', date: '2026-09-07', name: 'Labor Day'                  },
  { id: 'h04', date: '2026-11-11', name: 'Veterans Day'               },
  { id: 'h05', date: '2026-11-26', name: 'Thanksgiving Day'           },
  { id: 'h06', date: '2026-11-27', name: 'Day After Thanksgiving'     },
  { id: 'h07', date: '2026-12-25', name: 'Christmas Day'              },
  { id: 'h08', date: '2026-12-26', name: 'Christmas (Observed)'       },
  { id: 'h09', date: '2027-01-01', name: "New Year's Day"             },
  { id: 'h10', date: '2027-01-19', name: 'Martin Luther King Jr. Day' },
  { id: 'h11', date: '2027-02-16', name: "Presidents' Day"            },
];

// ---------------------------------------------------------------------------
// Forecast — deterministic seasonal variation per NDC × month
// ---------------------------------------------------------------------------

/**
 * Seasonal index keyed by 1-based month number.
 * Reflects realistic pharma packaging patterns:
 *   - Oct–Nov: year-end production push (high)
 *   - Dec–Feb: holiday + short-month slowdown (low)
 *   - Apr–May: spring ramp (moderate-high)
 *   - Jul:     summer maintenance shutdown (lowest)
 *   - Sep:     pre-Q4 build-up (high)
 */
const SEASONAL_INDEX: Record<number, number> = {
  1:  1.12,  // Jan — Q1 push after holiday restart
  2:  0.74,  // Feb — shortest month, slowest quarter
  3:  0.95,  // Mar — steady ramp
  4:  1.18,  // Apr — strong spring demand
  5:  1.28,  // May — peak spring / highest of year
  6:  0.88,  // Jun — early summer slowdown
  7:  0.68,  // Jul — planned maintenance shutdown, lowest
  8:  0.90,  // Aug — recovery
  9:  1.22,  // Sep — pre-Q4 inventory build
  10: 1.30,  // Oct — year-end peak, highest
  11: 1.20,  // Nov — sustained high
  12: 0.78,  // Dec — holiday wind-down
};

/**
 * Base monthly bottles per product, sized so that:
 *   - Average utilisation ≈ 62-65% (3 shifts, 7.5 h/shift, 20% downtime)
 *   - Peak utilisation (seasonal 1.30 × growth trend × stagger) ≤ 87%
 *
 * These numbers make Math.ceil(crewing × util × 1.2) vary between months:
 *   - LOW months  → loadFactor ~0.53 → PA = 2 per HS room
 *   - MID months  → loadFactor ~0.78 → PA = 3 per HS room
 *   - PEAK months → loadFactor ~1.02 → PA = 4 per HS room
 */
const BASE_BOTTLES: Record<string, number> = {
  Purple: 650000,
  Green:  550000,
  Gold:   520000,
  Blue:   470000,
  Silver: 520000,
  Black:  540000,
  RedC:   100000,
  RedD:   130000,
  RedB:     5000,
  WhiteA: 115000,
  WhiteB: 210000,
  SAPS:    3000,
};

export interface ForecastRow {
  NDC11: string;
  ForecastPeriod: string;
  ForecastBottles: number;
}

/** Generate 29 NDCs × 12 months forecast deterministically (no Math.random). */
export function generateForecast(calendar = MOCK_CALENDAR): ForecastRow[] {
  const rows: ForecastRow[] = [];

  MOCK_PRODUCTS.forEach((product, productIdx) => {
    const base = BASE_BOTTLES[product.RoomName] ?? 10000;

    calendar.forEach((cal, monthIdx) => {
      const calMonthNum = parseInt(cal.month.split('-')[1], 10);
      const seasonal = SEASONAL_INDEX[calMonthNum] ?? 1.0;
      // Stagger each product so rooms peak at different times (±15% offset).
      const stagger = 1 + ((productIdx % 7) - 3) * 0.05;
      // Growth trend: +1.2 % per month (reflects forecast ramp).
      const trend = 1 + monthIdx * 0.012;
      const bottles = Math.round(base * seasonal * stagger * trend);
      rows.push({ NDC11: product.NDC11, ForecastPeriod: cal.month, ForecastBottles: bottles });
    });
  });

  return rows;
}

// ---------------------------------------------------------------------------
// Changeover Summary — 9 rows (3 levels × 3 categories)
// ---------------------------------------------------------------------------
export const MOCK_CHANGEOVER_SUMMARY = [
  { clean_level: 'L1', room_category: 'HIGH', changeover_count: 178, avg_r2_minutes:  62.5, total_r2_minutes: 11125.0 },
  { clean_level: 'L1', room_category: 'LOW',  changeover_count:  37, avg_r2_minutes:  60.0, total_r2_minutes:  2220.0 },
  { clean_level: 'L1', room_category: 'OVER', changeover_count:  96, avg_r2_minutes:  35.0, total_r2_minutes:  3360.0 },
  { clean_level: 'L2', room_category: 'HIGH', changeover_count:  71, avg_r2_minutes: 132.5, total_r2_minutes:  9407.5 },
  { clean_level: 'L2', room_category: 'LOW',  changeover_count:  76, avg_r2_minutes:  77.5, total_r2_minutes:  5890.0 },
  { clean_level: 'L2', room_category: 'OVER', changeover_count:   0, avg_r2_minutes:   0.0, total_r2_minutes:     0.0 },
  { clean_level: 'L3', room_category: 'HIGH', changeover_count:  27, avg_r2_minutes: 165.0, total_r2_minutes:  4455.0 },
  { clean_level: 'L3', room_category: 'LOW',  changeover_count:  64, avg_r2_minutes: 105.0, total_r2_minutes:  6720.0 },
  { clean_level: 'L3', room_category: 'OVER', changeover_count:   3, avg_r2_minutes:  60.0, total_r2_minutes:   180.0 },
];

// ---------------------------------------------------------------------------
// Changeover Events — ~80 individual COPASTE-style records Oct 2025 – Mar 2026
// Proportional to MOCK_CHANGEOVER_SUMMARY counts; r2_minutes ±10% of avg.
// L1 HIGH ≈ 26, L1 LOW ≈ 5, L1 OVER ≈ 14, L2 HIGH ≈ 10, L2 LOW ≈ 11,
// L2 OVER = 0 (count 0 in summary), L3 HIGH ≈ 4, L3 LOW ≈ 9, L3 OVER ≈ 1
// ---------------------------------------------------------------------------
export const MOCK_CHANGEOVER_EVENTS: Array<{
  date: string;
  shift: string;
  room: string;
  clean_type: string;
  r2_minutes: number;
  copaste: string;
}> = [
  // --- L1 HIGH (26 events) ---
  { date: '2025-10-02', shift: 'First',   room: 'Purple', clean_type: 'L1', r2_minutes:  63, copaste: 'Purple_L1' },
  { date: '2025-10-07', shift: 'Second', room: 'Green',  clean_type: 'L1', r2_minutes:  58, copaste: 'Green_L1'  },
  { date: '2025-10-10', shift: 'First',   room: 'Gold',   clean_type: 'L1', r2_minutes:  65, copaste: 'Gold_L1'   },
  { date: '2025-10-16', shift: 'Second', room: 'Blue',   clean_type: 'L1', r2_minutes:  61, copaste: 'Blue_L1'   },
  { date: '2025-10-22', shift: 'First',   room: 'Silver', clean_type: 'L1', r2_minutes:  60, copaste: 'Silver_L1' },
  { date: '2025-11-03', shift: 'Second', room: 'Purple', clean_type: 'L1', r2_minutes:  67, copaste: 'Purple_L1' },
  { date: '2025-11-06', shift: 'First',   room: 'Green',  clean_type: 'L1', r2_minutes:  57, copaste: 'Green_L1'  },
  { date: '2025-11-12', shift: 'Second', room: 'Gold',   clean_type: 'L1', r2_minutes:  64, copaste: 'Gold_L1'   },
  { date: '2025-11-19', shift: 'First',   room: 'Blue',   clean_type: 'L1', r2_minutes:  63, copaste: 'Blue_L1'   },
  { date: '2025-12-02', shift: 'Second', room: 'Silver', clean_type: 'L1', r2_minutes:  59, copaste: 'Silver_L1' },
  { date: '2025-12-08', shift: 'First',   room: 'Purple', clean_type: 'L1', r2_minutes:  66, copaste: 'Purple_L1' },
  { date: '2025-12-15', shift: 'Second', room: 'Green',  clean_type: 'L1', r2_minutes:  62, copaste: 'Green_L1'  },
  { date: '2025-12-19', shift: 'First',   room: 'Gold',   clean_type: 'L1', r2_minutes:  60, copaste: 'Gold_L1'   },
  { date: '2026-01-05', shift: 'Second', room: 'Blue',   clean_type: 'L1', r2_minutes:  64, copaste: 'Blue_L1'   },
  { date: '2026-01-09', shift: 'First',   room: 'Silver', clean_type: 'L1', r2_minutes:  58, copaste: 'Silver_L1' },
  { date: '2026-01-14', shift: 'Second', room: 'Purple', clean_type: 'L1', r2_minutes:  68, copaste: 'Purple_L1' },
  { date: '2026-01-21', shift: 'First',   room: 'Green',  clean_type: 'L1', r2_minutes:  61, copaste: 'Green_L1'  },
  { date: '2026-02-03', shift: 'Second', room: 'Gold',   clean_type: 'L1', r2_minutes:  65, copaste: 'Gold_L1'   },
  { date: '2026-02-10', shift: 'First',   room: 'Blue',   clean_type: 'L1', r2_minutes:  63, copaste: 'Blue_L1'   },
  { date: '2026-02-17', shift: 'Second', room: 'Silver', clean_type: 'L1', r2_minutes:  57, copaste: 'Silver_L1' },
  { date: '2026-03-03', shift: 'First',   room: 'Purple', clean_type: 'L1', r2_minutes:  66, copaste: 'Purple_L1' },
  { date: '2026-03-07', shift: 'Second', room: 'Green',  clean_type: 'L1', r2_minutes:  62, copaste: 'Green_L1'  },
  { date: '2026-03-12', shift: 'First',   room: 'Gold',   clean_type: 'L1', r2_minutes:  60, copaste: 'Gold_L1'   },
  { date: '2026-03-18', shift: 'Second', room: 'Blue',   clean_type: 'L1', r2_minutes:  64, copaste: 'Blue_L1'   },
  { date: '2026-03-24', shift: 'First',   room: 'Silver', clean_type: 'L1', r2_minutes:  59, copaste: 'Silver_L1' },
  { date: '2026-03-28', shift: 'Second', room: 'Purple', clean_type: 'L1', r2_minutes:  67, copaste: 'Purple_L1' },

  // --- L1 LOW (5 events) ---
  { date: '2025-10-14', shift: 'First',   room: 'Black', clean_type: 'L1', r2_minutes:  61, copaste: 'Black_L1' },
  { date: '2025-12-05', shift: 'Second', room: 'RedC',  clean_type: 'L1', r2_minutes:  58, copaste: 'RedC_L1'  },
  { date: '2026-01-16', shift: 'First',   room: 'RedD',  clean_type: 'L1', r2_minutes:  63, copaste: 'RedD_L1'  },
  { date: '2026-02-20', shift: 'Second', room: 'Black', clean_type: 'L1', r2_minutes:  60, copaste: 'Black_L1' },
  { date: '2026-03-11', shift: 'First',   room: 'RedC',  clean_type: 'L1', r2_minutes:  57, copaste: 'RedC_L1'  },

  // --- L1 OVER (14 events) ---
  { date: '2025-10-03', shift: 'Second', room: 'WhiteA', clean_type: 'L1', r2_minutes:  35, copaste: 'WhiteA_L1' },
  { date: '2025-10-17', shift: 'First',   room: 'WhiteB', clean_type: 'L1', r2_minutes:  33, copaste: 'WhiteB_L1' },
  { date: '2025-10-28', shift: 'Second', room: 'WhiteA', clean_type: 'L1', r2_minutes:  37, copaste: 'WhiteA_L1' },
  { date: '2025-11-07', shift: 'First',   room: 'WhiteB', clean_type: 'L1', r2_minutes:  34, copaste: 'WhiteB_L1' },
  { date: '2025-11-20', shift: 'Second', room: 'WhiteA', clean_type: 'L1', r2_minutes:  36, copaste: 'WhiteA_L1' },
  { date: '2025-12-04', shift: 'First',   room: 'WhiteB', clean_type: 'L1', r2_minutes:  32, copaste: 'WhiteB_L1' },
  { date: '2025-12-18', shift: 'Second', room: 'WhiteA', clean_type: 'L1', r2_minutes:  38, copaste: 'WhiteA_L1' },
  { date: '2026-01-08', shift: 'First',   room: 'WhiteB', clean_type: 'L1', r2_minutes:  35, copaste: 'WhiteB_L1' },
  { date: '2026-01-22', shift: 'Second', room: 'WhiteA', clean_type: 'L1', r2_minutes:  33, copaste: 'WhiteA_L1' },
  { date: '2026-02-05', shift: 'First',   room: 'WhiteB', clean_type: 'L1', r2_minutes:  37, copaste: 'WhiteB_L1' },
  { date: '2026-02-19', shift: 'Second', room: 'WhiteA', clean_type: 'L1', r2_minutes:  34, copaste: 'WhiteA_L1' },
  { date: '2026-03-04', shift: 'First',   room: 'WhiteB', clean_type: 'L1', r2_minutes:  36, copaste: 'WhiteB_L1' },
  { date: '2026-03-14', shift: 'Second', room: 'WhiteA', clean_type: 'L1', r2_minutes:  32, copaste: 'WhiteA_L1' },
  { date: '2026-03-25', shift: 'First',   room: 'WhiteB', clean_type: 'L1', r2_minutes:  38, copaste: 'WhiteB_L1' },

  // --- L2 HIGH (10 events) ---
  { date: '2025-10-09', shift: 'Second', room: 'Purple', clean_type: 'L2', r2_minutes: 135, copaste: 'Purple_L2' },
  { date: '2025-10-24', shift: 'First',   room: 'Green',  clean_type: 'L2', r2_minutes: 128, copaste: 'Green_L2'  },
  { date: '2025-11-13', shift: 'Second', room: 'Gold',   clean_type: 'L2', r2_minutes: 140, copaste: 'Gold_L2'   },
  { date: '2025-11-26', shift: 'First',   room: 'Blue',   clean_type: 'L2', r2_minutes: 132, copaste: 'Blue_L2'   },
  { date: '2025-12-10', shift: 'Second', room: 'Silver', clean_type: 'L2', r2_minutes: 129, copaste: 'Silver_L2' },
  { date: '2025-12-22', shift: 'First',   room: 'Purple', clean_type: 'L2', r2_minutes: 136, copaste: 'Purple_L2' },
  { date: '2026-01-13', shift: 'Second', room: 'Green',  clean_type: 'L2', r2_minutes: 133, copaste: 'Green_L2'  },
  { date: '2026-02-06', shift: 'First',   room: 'Gold',   clean_type: 'L2', r2_minutes: 138, copaste: 'Gold_L2'   },
  { date: '2026-02-24', shift: 'Second', room: 'Blue',   clean_type: 'L2', r2_minutes: 130, copaste: 'Blue_L2'   },
  { date: '2026-03-16', shift: 'First',   room: 'Silver', clean_type: 'L2', r2_minutes: 134, copaste: 'Silver_L2' },

  // --- L2 LOW (11 events) ---
  { date: '2025-10-06', shift: 'Second', room: 'Black', clean_type: 'L2', r2_minutes:  78, copaste: 'Black_L2' },
  { date: '2025-10-20', shift: 'First',   room: 'RedC',  clean_type: 'L2', r2_minutes:  75, copaste: 'RedC_L2'  },
  { date: '2025-11-04', shift: 'Second', room: 'RedD',  clean_type: 'L2', r2_minutes:  80, copaste: 'RedD_L2'  },
  { date: '2025-11-17', shift: 'First',   room: 'Black', clean_type: 'L2', r2_minutes:  77, copaste: 'Black_L2' },
  { date: '2025-12-01', shift: 'Second', room: 'RedC',  clean_type: 'L2', r2_minutes:  74, copaste: 'RedC_L2'  },
  { date: '2025-12-16', shift: 'First',   room: 'RedD',  clean_type: 'L2', r2_minutes:  82, copaste: 'RedD_L2'  },
  { date: '2026-01-07', shift: 'Second', room: 'Black', clean_type: 'L2', r2_minutes:  76, copaste: 'Black_L2' },
  { date: '2026-01-23', shift: 'First',   room: 'RedC',  clean_type: 'L2', r2_minutes:  79, copaste: 'RedC_L2'  },
  { date: '2026-02-11', shift: 'Second', room: 'RedD',  clean_type: 'L2', r2_minutes:  73, copaste: 'RedD_L2'  },
  { date: '2026-03-02', shift: 'First',   room: 'Black', clean_type: 'L2', r2_minutes:  81, copaste: 'Black_L2' },
  { date: '2026-03-19', shift: 'Second', room: 'RedC',  clean_type: 'L2', r2_minutes:  77, copaste: 'RedC_L2'  },

  // --- L3 HIGH (4 events) ---
  { date: '2025-10-30', shift: 'First',   room: 'Purple', clean_type: 'L3', r2_minutes: 168, copaste: 'Purple_L3' },
  { date: '2025-12-12', shift: 'Second', room: 'Green',  clean_type: 'L3', r2_minutes: 162, copaste: 'Green_L3'  },
  { date: '2026-01-28', shift: 'First',   room: 'Gold',   clean_type: 'L3', r2_minutes: 170, copaste: 'Gold_L3'   },
  { date: '2026-03-10', shift: 'Second', room: 'Blue',   clean_type: 'L3', r2_minutes: 165, copaste: 'Blue_L3'   },

  // --- L3 LOW (9 events) ---
  { date: '2025-10-13', shift: 'First',   room: 'Black', clean_type: 'L3', r2_minutes: 107, copaste: 'Black_L3' },
  { date: '2025-11-05', shift: 'Second', room: 'RedC',  clean_type: 'L3', r2_minutes: 103, copaste: 'RedC_L3'  },
  { date: '2025-11-25', shift: 'First',   room: 'RedD',  clean_type: 'L3', r2_minutes: 110, copaste: 'RedD_L3'  },
  { date: '2025-12-17', shift: 'Second', room: 'Black', clean_type: 'L3', r2_minutes: 105, copaste: 'Black_L3' },
  { date: '2026-01-12', shift: 'First',   room: 'RedC',  clean_type: 'L3', r2_minutes: 100, copaste: 'RedC_L3'  },
  { date: '2026-01-27', shift: 'Second', room: 'RedD',  clean_type: 'L3', r2_minutes: 108, copaste: 'RedD_L3'  },
  { date: '2026-02-16', shift: 'First',   room: 'Black', clean_type: 'L3', r2_minutes: 104, copaste: 'Black_L3' },
  { date: '2026-03-06', shift: 'Second', room: 'RedC',  clean_type: 'L3', r2_minutes: 112, copaste: 'RedC_L3'  },
  { date: '2026-03-23', shift: 'First',   room: 'RedD',  clean_type: 'L3', r2_minutes: 106, copaste: 'RedD_L3'  },

  // --- L3 OVER (1 event) ---
  { date: '2026-02-13', shift: 'Second', room: 'WhiteA', clean_type: 'L3', r2_minutes:  61, copaste: 'WhiteA_L3' },
];

// ---------------------------------------------------------------------------
// Job History — 18 months of actual data (Oct 2025 – Mar 2027)
// ---------------------------------------------------------------------------
export const MOCK_JOB_HISTORY = [
  // Q4 2025
  { yr: 2025, mth: 10, jobs: 142, total_bottles: 3840000, total_pills: 115200000 },
  { yr: 2025, mth: 11, jobs: 128, total_bottles: 3450000, total_pills: 103500000 },
  { yr: 2025, mth: 12, jobs: 135, total_bottles: 3620000, total_pills: 108600000 },
  // Q1 2026
  { yr: 2026, mth:  1, jobs: 148, total_bottles: 3990000, total_pills: 119700000 },
  { yr: 2026, mth:  2, jobs: 131, total_bottles: 3540000, total_pills: 106200000 },
  { yr: 2026, mth:  3, jobs: 155, total_bottles: 4180000, total_pills: 125400000 },
  // Q2 2026
  { yr: 2026, mth:  4, jobs: 143, total_bottles: 3860000, total_pills: 115800000 },
  { yr: 2026, mth:  5, jobs: 161, total_bottles: 4340000, total_pills: 130200000 },
  { yr: 2026, mth:  6, jobs: 138, total_bottles: 3720000, total_pills: 111600000 },
  // Q3 2026
  { yr: 2026, mth:  7, jobs: 152, total_bottles: 4100000, total_pills: 123000000 },
  { yr: 2026, mth:  8, jobs: 167, total_bottles: 4500000, total_pills: 135000000 },
  { yr: 2026, mth:  9, jobs: 144, total_bottles: 3880000, total_pills: 116400000 },
  // Q4 2026
  { yr: 2026, mth: 10, jobs: 159, total_bottles: 4290000, total_pills: 128700000 },
  { yr: 2026, mth: 11, jobs: 141, total_bottles: 3800000, total_pills: 114000000 },
  { yr: 2026, mth: 12, jobs: 153, total_bottles: 4130000, total_pills: 123900000 },
  // Q1 2027
  { yr: 2027, mth:  1, jobs: 162, total_bottles: 4370000, total_pills: 131100000 },
  { yr: 2027, mth:  2, jobs: 147, total_bottles: 3970000, total_pills: 119100000 },
  { yr: 2027, mth:  3, jobs: 170, total_bottles: 4590000, total_pills: 137700000 },
];

// ---------------------------------------------------------------------------
// In-run crewing ratios
// ---------------------------------------------------------------------------
export const MOCK_IN_RUN_CREWING: Record<string, { PA: number; MO: number; QI: number }> = {
  'High Speed 1': { PA: 3,   MO: 3,   QI: 1   },
  'High Speed 2': { PA: 3,   MO: 3,   QI: 1   },
  'Medium Speed': { PA: 2,   MO: 3,   QI: 1   },
  'Low Speed 1':  { PA: 1,   MO: 2,   QI: 1   },
  'Low Speed 2':  { PA: 1,   MO: 2,   QI: 1   },
  'Overlay':      { PA: 1,   MO: 1,   QI: 1   },
  'SAPS':         { PA: 1,   MO: 1,   QI: 1   },
};

// ---------------------------------------------------------------------------
// Changeover crewing ratios
// ---------------------------------------------------------------------------
export const MOCK_CHANGEOVER_CREWING: Record<string, { PA: number; MO: number; QI: number }> = {
  'L1_High Speed 1': { PA: 1.0, MO: 1.0, QI: 0.5 },
  'L1_High Speed 2': { PA: 1.0, MO: 1.0, QI: 0.5 },
  'L1_Medium Speed': { PA: 1.0, MO: 1.0, QI: 0.5 },
  'L1_Low Speed 1':  { PA: 0.5, MO: 1.0, QI: 0.5 },
  'L1_Low Speed 2':  { PA: 0.5, MO: 1.0, QI: 0.5 },
  'L1_Overlay':      { PA: 0.5, MO: 0.5, QI: 0.5 },
  'L2_High Speed 1': { PA: 1.5, MO: 1.5, QI: 1.0 },
  'L2_High Speed 2': { PA: 1.5, MO: 1.5, QI: 1.0 },
  'L2_Medium Speed': { PA: 1.5, MO: 1.5, QI: 1.0 },
  'L2_Low Speed 1':  { PA: 1.0, MO: 1.5, QI: 1.0 },
  'L2_Low Speed 2':  { PA: 1.0, MO: 1.5, QI: 1.0 },
  'L2_Overlay':      { PA: 1.0, MO: 1.0, QI: 1.0 },
  'L3_High Speed 1': { PA: 2.0, MO: 2.0, QI: 1.0 },
  'L3_High Speed 2': { PA: 2.0, MO: 2.0, QI: 1.0 },
  'L3_Medium Speed': { PA: 2.0, MO: 2.0, QI: 1.0 },
  'L3_Low Speed 1':  { PA: 1.5, MO: 2.0, QI: 1.0 },
  'L3_Low Speed 2':  { PA: 1.5, MO: 2.0, QI: 1.0 },
  'L3_Overlay':      { PA: 1.5, MO: 1.5, QI: 1.0 },
};

// ---------------------------------------------------------------------------
// Default planning parameters
// ---------------------------------------------------------------------------
export const DEFAULT_PLANNING_PARAMS: Record<string, number> = {
  downtime_factor:             0.20,
  hours_per_shift:             8.00,
  hours_per_shift_room:        7.50,
  shifts_per_day:              2.00,
  pa_leads:                    2.00,
  mo_leads:                    2.00,
  qi_leads:                    2.00,
  aggregation_staff:           2.00,
  shift_coverage:              2.00,
  qls:                         1.00,
  lookback_months:             6.00,
  forecast_jobs_override_pct:  0.00,
};

// ---------------------------------------------------------------------------
// Planning params as structured objects (for the Explorer / reference view)
// ---------------------------------------------------------------------------
export const MOCK_PLANNING_PARAMS_RAW: PlanningParam[] = [
  { id:  1, parameter: 'downtime_factor',            value: 0.20, label: 'Downtime Factor',              unit: '%',      description: 'Fraction of time lost to unplanned downtime' },
  { id:  2, parameter: 'hours_per_shift',             value: 8.00, label: 'Hours per Shift',              unit: 'hours',  description: 'Paid hours per operator shift' },
  { id:  3, parameter: 'hours_per_shift_room',        value: 7.50, label: 'Hours per Shift (Room)',       unit: 'hours',  description: 'Productive machine-run hours per shift' },
  { id:  4, parameter: 'shifts_per_day',              value: 2.00, label: 'Shifts per Day',               unit: 'shifts', description: 'Number of production shifts per work day' },
  { id:  5, parameter: 'pa_leads',                    value: 2.00, label: 'PA Leads',                     unit: 'HC',     description: 'Fixed PA lead headcount regardless of room load' },
  { id:  6, parameter: 'mo_leads',                    value: 2.00, label: 'MO Leads',                     unit: 'HC',     description: 'Fixed MO lead headcount regardless of room load' },
  { id:  7, parameter: 'qi_leads',                    value: 2.00, label: 'QI Leads',                     unit: 'HC',     description: 'Fixed QI lead headcount regardless of room load' },
  { id:  8, parameter: 'aggregation_staff',           value: 2.00, label: 'Aggregation Staff',            unit: 'HC',     description: 'Fixed staff dedicated to packaging aggregation' },
  { id:  9, parameter: 'shift_coverage',              value: 2.00, label: 'Shift Coverage',               unit: 'HC',     description: 'Relief headcount to cover shift overlaps' },
  { id: 10, parameter: 'qls',                         value: 1.00, label: 'QLS',                          unit: 'HC',     description: 'Quality lab support staff count' },
  { id: 11, parameter: 'lookback_months',             value: 6.00, label: 'Lookback Months',              unit: 'months', description: 'History window used for forecast job averaging' },
  { id: 12, parameter: 'forecast_jobs_override_pct',  value: 0.00, label: 'Forecast Jobs Override %',     unit: '%',      description: 'Manual override percentage applied to forecast job count' },
];

// ---------------------------------------------------------------------------
// Reference data
// ---------------------------------------------------------------------------
export const MOCK_REFERENCE_DATA = {
  run_types: [
    { id: 1, description: 'RUN'     },
    { id: 2, description: 'DUMP'    },
    { id: 3, description: 'OVERLAY' },
    { id: 4, description: 'RECAP'   },
  ],
  clean_types: [
    { id: 1, code: 'L1', description: 'Level 1 — wipe-down only',         avg_minutes:  42 },
    { id: 2, code: 'L2', description: 'Level 2 — full room clean',         avg_minutes:  85 },
    { id: 3, code: 'L3', description: 'Level 3 — deep clean + validation', avg_minutes: 165 },
  ],
  coating_types: [
    { id: 1, description: 'Film Coat'        },
    { id: 2, description: 'Sugar Coat'       },
    { id: 3, description: 'Enteric Coat'     },
    { id: 4, description: 'Uncoated'         },
    { id: 5, description: 'Hard Shell (Cap)' },
  ],
};

// ---------------------------------------------------------------------------
// BPM data — mirrors pps_app_bpmbyndcandjobtype table shape
// ---------------------------------------------------------------------------
export const MOCK_BPM_DATA = MOCK_PRODUCTS.map((p) => ({
  ndc:       p.NDC11,
  bpm:       p.BPM,
  pa_hc:     p.RoomType === 'HIGH' ? 3 : p.RoomType === 'LOW' ? 1 : 1,
  mo_hc:     p.RoomType === 'HIGH' ? 3 : p.RoomType === 'LOW' ? 2 : 1,
  qi_hc:     1,
  room_type: p.RoomType,
  job_type:  p.JobType,
  room_name: p.RoomName,
  ebq:       p.Ebq,
}));

// ---------------------------------------------------------------------------
// Indirect summary — 12 months of aggregate MAS-indirect data
// ---------------------------------------------------------------------------
export const MOCK_INDIRECT_SUMMARY = MOCK_CALENDAR.map((cal, idx) => ({
  month:         cal.month,
  ndc_count:     45,
  total_bottles: 490000 + idx * 3500,
}));

// ---------------------------------------------------------------------------
// Dynamic calendar builder — generates 12 months from any start month
// ---------------------------------------------------------------------------
const WORK_DAYS_BY_MONTH = [21, 20, 23, 21, 21, 22, 22, 22, 21, 23, 21, 22]; // Jan–Dec typical

export function buildCalendar(startYearMonth: string): { month: string; work_days: number }[] {
  const [startYr, startMn] = startYearMonth.split('-').map(Number);
  return Array.from({ length: 12 }, (_, i) => {
    const d = new Date(startYr, startMn - 1 + i, 1);
    return {
      month: `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`,
      work_days: WORK_DAYS_BY_MONTH[d.getMonth()],
    };
  });
}
